export enum EmailVariablesKeys {
  sku = 'sku',
  imageUrl = 'imageUrl',
  userId = 'userId',
}

export const emailVariableLabels: Record<EmailVariablesKeys, string> = {
  [EmailVariablesKeys.sku]: 'SKU / Product ID',
  [EmailVariablesKeys.userId]: 'User ID',
  [EmailVariablesKeys.imageUrl]: 'ImageURL',
};

export const emailVariableTooltips: Record<EmailVariablesKeys, string> = {
  [EmailVariablesKeys.sku]:
    'Select the event field that holds the product’s SKU or ID. This connects the right product to the email.',
  [EmailVariablesKeys.imageUrl]:
    'Select the event field that holds the product’s image URL. This shows the correct product image in the email.',
  [EmailVariablesKeys.userId]:
    'Select the event field that holds the Syte-generated user UUID. This tracks the user’s session for personalization.',
};

export const defaultEmailVariables = {
  [EmailVariablesKeys.sku]: '',
  [EmailVariablesKeys.imageUrl]: '',
  [EmailVariablesKeys.userId]: '',
};
